import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=3f87da14&scoped=true&"
var script = {}
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=3f87da14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87da14",
  null
  
)

export default component.exports